export { default as CtaBlockWithButtons } from './CtaBlockWithButtons';
export { ctaBlockWithButtonsAdapter } from './adapters';
